export default "__VITE_ASSET__e98028d6__"